import { useState, type FC } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { Send } from '@mint-lib/icons';
import {
  Button,
  Chip,
  Divider,
  typographyVariants,
} from '@mint-lib/tw-components';

import { EntitySpecificFields } from '../../types/shared';
import SendNewRequestModal from '../modals/SendNewRequestModal/SendNewRequestModal.jsx';

const RequesterDraft: FC<EntitySpecificFields> = ({
  entityType,
  entityId,
  entityName,
  entitySource,
  entityMetadata,
}) => {
  const { t } = useTranslation('@mint-lib/approval-flow-circuit_v2');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="flex items-center gap-2">
        <div className="flex items-center gap-2">
          <span
            className={typographyVariants({
              variant: 'caption1',
              color: 'secondary',
            })}
          >
            {t('Status')}:
          </span>
          <Chip variant="outline" color="silver" size="medium">
            {t('Draft')}
          </Chip>
        </div>
        <Divider orientation="vertical" className="max-h-6" />
        <Button
          data-dd-action-name="Show New request modal"
          variant="outlined"
          color="primary"
          size="medium"
          onClick={showModal}
        >
          <Send />
          {t('Send for approval')}
        </Button>
      </div>
      <SendNewRequestModal
        open={isModalOpen}
        onClose={closeModal}
        entityType={entityType}
        entityId={entityId}
        entityName={entityName}
        entitySource={entitySource}
        entityMetadata={entityMetadata}
      />
    </>
  );
};

export default RequesterDraft;
